import { ISelectItem } from '@lla-platform/core/core-ui'

export enum VendorDocumentType {
  SupplierInvoice = 'SupplierInvoice',
  Bill = 'Bill',
  CreditSlip = 'CreditSlip',
  Warranty = 'Warranty'
}

export const VendorDocumentTypeToLabel: Record<string, string> = {
  SupplierInvoice: 'Supplier invoice',
  Bill: 'Bill',
  CreditSlip: 'Credit slip',
  Warranty: 'Warranty'
}

export const VendorDocumentTypeItems: ISelectItem[] = Object.values(VendorDocumentType).map((value) => ({
  label: VendorDocumentTypeToLabel[value],
  value
}))
